import { useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';
import { axios } from 'configurations/axios';

export function useGetImageForViewer(url: string | undefined) {
    const { jwtToken } = useSessionStore(state => ({
        jwtToken: state.jwtToken
    }));

    return useQuery(['getImageForViewer', url], async () => {
        const response = await axios.get(url!, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`
            },
            responseType: 'blob'
        });

        return response.data;
    }, {
        refetchOnWindowFocus: false,
        enabled: !!url && !!jwtToken,
    });
}
